import React, {useEffect, useMemo, useRef, useState} from 'react'
import ContractorSection from './sections/ContractorSection';
import OfferSection from './sections/OfferSection';
import StatisticSection from "./sections/StatisticSection";
import StatisticsService from "services/StatisticsService";
import OfferDecryptionSection from "./sections/OfferDecryptionSection";
import DocumentsSection from "./sections/DocumentsSection";
import NavigationBar from "components/complex/floatingMenu/NavigationBar";
import RouterPath from "libs/RouterPath";
import {modify} from "services/ModificationService";
import {isDemandModification, isDemandOfferCollection} from "libs/getDemandStatus";
import createButton from "components/complex/floatingMenu/createButton";
import Workspace from "components/Workspace";
import {connect} from "react-redux";
import {makeStyles} from "@material-ui/core";
import ResendOfferInvitationPopup from "./components/ResendOfferInvitationPopup";
import TilesRow from "./components/TilesRow";
import Loading from "components/Loading";
import HeaderService from "services/HeaderService";
import ListIcon from "@material-ui/icons/List";
import DemandRelatedObjectsPopup from "components/popup/relatedObjects/DemandRelatedObjectsPopup";
import PublishService from "services/PublishService";
import Poll from "components/popup/poll/Poll";
import SiwzService from "services/SiwzService";
import RepoService from "services/RepoService";
import RfxRoundService from "services/RfxRoundService";
import PrivilegeService from "services/PrivilegeService";
import DemandService from "services/DemandService";

const useStyle = makeStyles(theme => ({
    menuBar: {
        direction: 'rtl',
        marginBottom: theme.spacing(2)
    }
}))

const rp = RouterPath.myProcedure;

function Part2(
    {
        match,
        demandStatistics,
        currentRfxRound,
        demandHeader,
        siwzEditable = false,
        repoEditable = false,
        rfxPrivileges = {},
        demandPrivileges = {}
    }) {

    const demandId = match.params.id;
    const classes = useStyle();

    const [working, setWorking] = useState(false);
    const [refreshStats, setRefreshStats] = useState(0);
    const [resendInvitationPopupOpen, setResendInvitationPopup] = useState(false);
    const [relatedObjectPopup, setRelatedObjectPopup] = useState(false);
    const [firstPublication, setFirstPublication] = useState(()=> PublishService.isFirstPublication(demandId));
    const intervalId = useRef(0);
    const loadingInProgress = useRef(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const offerCollection = useMemo(() => isDemandOfferCollection(), [demandHeader]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const modification = useMemo(() => isDemandModification(), [demandHeader]);

    useEffect(() => {
        if (!loadingInProgress.current && currentRfxRound?.id) {
            loadingInProgress.current = true;
            StatisticsService.getStats(demandId, currentRfxRound.id).finally(() => loadingInProgress.current = false);
        }
    }, [refreshStats, currentRfxRound, demandId])

    useEffect(() => {
        setRefreshStats(x => x + 1);
    }, [currentRfxRound])

    useEffect(() => {
        StatisticsService.getCurrentRound(demandId).then((res)=> {
            if(res)
                RfxRoundService.getBuyerPrivileges(res.id)
        });
        intervalId.current = setInterval(() => {
            setRefreshStats(x => x + 1)
        }, 20000);
        SiwzService.isSiwzEditable(demandId);
        RepoService.isRepoEditable(demandId);
        DemandService.getBuyerPrivileges(demandId);

        return () => {
            if (intervalId.current)
                clearInterval(intervalId.current);
            StatisticsService.clearStats();
            StatisticsService.clearCurrentRound();
            HeaderService.clear();
            SiwzService.clearResources(SiwzService.SIWZ_EDITABLE_RESOURCE_ID);
            RepoService.clearResources(RepoService.REPO_EDITABLE_RESOURCE_ID);
            PrivilegeService.cleanupPrivileges(PrivilegeService.RFX_PRIVILEGE_STORE_KEY);
            PrivilegeService.cleanupPrivileges(PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY);
        }
        // eslint-disable-next-line
    }, []);


    const endTimeCallback = () => {
        StatisticsService.getCurrentRound(demandId);
        setRefreshStats(x => x + 1);
    };

    const handlePrevClick = () => {
        const href = RouterPath.createPath(rp.steps.MP_1_ID, {id: demandId});
        RouterPath.redirect(href)
    };

    const handleModifyClick = () => {
        if (!working) {
            setWorking(true);
            modify(demandId)
                .then((resp) => {
                    if (resp) {
                        handlePrevClick();
                    } else {
                        setWorking(false);
                    }
                }).catch(() => {
                setWorking(false);
            })
        }
    };


    const getNavigationBarButtons = () => {
        const buttons = [];
        if (!demandHeader || !currentRfxRound) {
            return buttons;
        }
        const offerCollection = isDemandOfferCollection();
        if (demandHeader.hasPlanItems || demandHeader.hasPurchaseRequests) {
            buttons.push(createButton('related_objects', () => setRelatedObjectPopup(true),"outlined", ListIcon, 'primary', false));
        }
        buttons.push(createButton("resend_offer_invitation", () => setResendInvitationPopup(true), "outlined", undefined, "primary", !rfxPrivileges.RESEND_INVITATION || working || !(offerCollection || modification)));
        buttons.push(createButton("modify", handleModifyClick, undefined, undefined, "primary", !demandPrivileges.MODIFY || working || !offerCollection));
        return buttons;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const navigationBarButtons = useMemo(getNavigationBarButtons, [demandHeader, currentRfxRound, rfxPrivileges, demandPrivileges, working])

    return (
        <>
            {(Boolean(currentRfxRound) && Boolean(demandHeader) && Boolean(demandStatistics)) ?
                <>
                    <NavigationBar buttons={navigationBarButtons} classesObj={classes}/>
                    <Workspace
                        render={<>
                            {(offerCollection || modification) &&
                                <StatisticSection currentRfxRound={currentRfxRound} endTimeCallback={endTimeCallback}/>
                            }
                            <TilesRow demandStatistics={demandStatistics}
                                      offerCollectionOrModification={offerCollection || modification}/>
                            <OfferDecryptionSection demandStatistics={demandStatistics}
                                                    currentRfxRound={currentRfxRound}/>
                            {(offerCollection || modification) &&
                                <OfferSection/>
                            }
                            <ContractorSection demandHeader={demandHeader} demandStatistics={demandStatistics} currentRfxRound={currentRfxRound} rfxPrivileges={rfxPrivileges}/>
                            {(offerCollection || modification) &&
                                <DocumentsSection
                                    siwzEditable={siwzEditable}
                                    repoEditable={repoEditable}
                                />
                            }
                        </>}
                    />
                </>
                :
                <Loading/>
            }
            {resendInvitationPopupOpen &&
                <ResendOfferInvitationPopup demandId={demandId} roundId={currentRfxRound.id}
                                            onClose={() => setResendInvitationPopup(false)}/>}
            {
                relatedObjectPopup &&
                <DemandRelatedObjectsPopup demandId={demandId} onClose={() => setRelatedObjectPopup(false)}/>
            }
            {
                firstPublication && <Poll onClose={()=> setFirstPublication(false)} pollType='demand_publication' demandId={demandId} />
            }
        </>
    )
}


const mapStateToProps = state => ({
        demandHeader: state.resources.demandHeader,
        demandStatistics: state.resources[StatisticsService.DEMAND_STATISTICS_RESOURCE_ID],
        currentRfxRound: state.resources[StatisticsService.CURRENT_RFX_RESOURCE_ID],
        siwzEditable: state.resources[SiwzService.SIWZ_EDITABLE_RESOURCE_ID],
        repoEditable: state.resources[RepoService.REPO_EDITABLE_RESOURCE_ID],
        rfxPrivileges: state.privileges[PrivilegeService.RFX_PRIVILEGE_STORE_KEY],
        demandPrivileges: state.privileges[PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY],
    });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Part2);